// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern news card styles for corporate look */
.modern-news-cards {
  gap: 2rem;
}
.modern-news-card {
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  overflow: hidden;
  min-width: 260px;
  max-width: 320px;
  background: #fff;
  position: relative;
  transition: transform 0.18s, box-shadow 0.18s;
  border: 1px solid #e5e7eb;
}
.modern-news-card:hover {
  transform: translateY(-4px) scale(1.03);
  box-shadow: 0 12px 32px rgba(0,0,0,0.16);
}
.modern-news-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.08) 70%);
  z-index: 1;
}
.modern-news-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1.1rem 1rem 0.8rem 1rem;
  color: #fff;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.modern-news-category {
  font-size: 0.8rem;
  font-weight: 700;
  background: #01978d;
  padding: 0.22rem 0.7rem;
  border-radius: 9999px;
  margin-bottom: 0.5rem;
  letter-spacing: 0.03em;
  box-shadow: 0 2px 8px rgba(1,151,141,0.08);
}
.modern-news-title {
  font-size: 1.08rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0,0,0,0.10);
}
/* Modern app card styles */
.modern-app-card {
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 1.5rem 1rem;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.5rem;
}
.modern-app-card:hover {
  transform: translateY(-6px) scale(1.04);
  box-shadow: 0 12px 32px rgba(0,0,0,0.16);
}
.dashboard-app-icon-wrapper {
  border-radius: 16px !important;
  width: 64px !important;
  height: 64px !important;
  margin-bottom: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07) !important;
  background: rgba(255,255,255,0.85) !important;
}
.dashboard-app-title {
  font-weight: 700;
  font-size: 1.15rem;
  color: #222;
  margin-bottom: 4px;
}
.dashboard-app-subtitle {
  font-size: 0.95rem;
  color: #555;
  font-weight: 500;
}

:root {
  --awlone-brand-color: #01978d;
  --text-dark: #1f2937;
  --text-medium: #6b7280;
  --card-border: #e5e7eb;
  --card-bg: #ffffff;
  --shadow-light: rgba(4, 29, 56, 0.05);
  --shadow-hover: rgba(4, 29, 56, 0.12);
  --primary-font: 'Inter', sans-serif;
}

.home-dashboard-bg {
  font-family: var(--primary-font);
  background-color: #f9fafb;
}

.sticky-top-header {
  position: sticky;
  top: 0;
  background-color: var(--card-bg);
  box-shadow: 0 4px 12px var(--shadow-light);
  z-index: 1000;
  padding: 0.8rem 1.5rem;
  display: flex;
  justify-content: center;
}
.portal-branding { display: flex; align-items: center; justify-content: space-between; width: 100%; max-width: 800px; }
.portal-title { font-size: 1.8rem; font-weight: 800; color: var(--awlone-brand-color); }
.profile-icon-container { color: var(--text-medium); cursor: pointer; transition: color 0.2s; }
.profile-icon-container:hover { color: var(--awlone-brand-color); }

.main-content-area {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 1.5rem;
  box-sizing: border-box;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 1rem;
}

.news-section {
  margin-bottom: 2.5rem;
}

.news-carousel-container {
  display: flex;
  gap: 1rem;
  overflow-x: auto; 
  padding-bottom: 1rem; 
  -ms-overflow-style: none;  
  scrollbar-width: none; 
}
  .marquee-wrapper {
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  .marquee-inner {
    display: flex;
    animation: marquee-scroll 16s linear infinite;
  }
  @keyframes marquee-scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-60%); }
  }
.news-carousel-container::-webkit-scrollbar {
  display: none; 
}

.news-card {
  flex: 0 0 280px; 
  height: 180px;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 12px var(--shadow-light);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.news-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px var(--shadow-hover);
}

.news-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 60%);
}

.news-card-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  color: white;
}
.news-category {
  font-size: 0.75rem;
  font-weight: 600;
  background-color: var(--awlone-brand-color);
  padding: 0.25rem 0.6rem;
  border-radius: 9999px;
  display: inline-block;
  margin-bottom: 0.5rem;
}
.news-title {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.3;
}

/* Two-column grid for apps, always mobile-friendly */
.dashboard-apps-container.two-column {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
}

@media (max-width: 700px) {
  .dashboard-apps-container.two-column {
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    padding: 0 0.5rem;
  }
}

.dashboard-app-module {
  text-align: center;
  cursor: pointer;
}
.dashboard-app-icon-wrapper {
  width: 80px; 
  height: 80px; 
  border-radius: 1.25rem;
  background-color: var(--card-bg);
  box-shadow: 0 4px 12px var(--shadow-light);
  border: 1px solid var(--card-border);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 0.75rem;
  padding: 0.75rem;
  box-sizing: border-box;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.dashboard-app-module:hover .dashboard-app-icon-wrapper {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px var(--shadow-hover);
}

.app-logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.dashboard-app-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-dark);
}


@media (max-width: 600px) {
  .dashboard-apps-container {
    grid-template-columns: repeat(3, 1fr); 
    gap: 1rem;
  }
  .dashboard-app-icon-wrapper {
      width: 70px;
      height: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./src/HomeDashboard.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;AAC3B;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,uCAAuC;AACzC;AACA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,uCAAuC;EACvC,oBAAoB;EACpB,2CAA2C;EAC3C,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,iDAAiD;EACjD,6CAA6C;AAC/C;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAGA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gCAAgC;EAChC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACtH,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE;AACvF,0BAA0B,yBAAyB,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC9F,gCAAgC,gCAAgC,EAAE;;AAElE;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,aAAa;IACb,6CAA6C;EAC/C;EACA;IACE,KAAK,wBAAwB,EAAE;IAC/B,OAAO,2BAA2B,EAAE;EACtC;AACF;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,qDAAqD;AACvD;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,0CAA0C;EAC1C,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;AACvD;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;MACI,WAAW;MACX,YAAY;EAChB;AACF","sourcesContent":["/* Modern news card styles for corporate look */\n.modern-news-cards {\n  gap: 2rem;\n}\n.modern-news-card {\n  border-radius: 18px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.10);\n  overflow: hidden;\n  min-width: 260px;\n  max-width: 320px;\n  background: #fff;\n  position: relative;\n  transition: transform 0.18s, box-shadow 0.18s;\n  border: 1px solid #e5e7eb;\n}\n.modern-news-card:hover {\n  transform: translateY(-4px) scale(1.03);\n  box-shadow: 0 12px 32px rgba(0,0,0,0.16);\n}\n.modern-news-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.08) 70%);\n  z-index: 1;\n}\n.modern-news-content {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 1.1rem 1rem 0.8rem 1rem;\n  color: #fff;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.modern-news-category {\n  font-size: 0.8rem;\n  font-weight: 700;\n  background: #01978d;\n  padding: 0.22rem 0.7rem;\n  border-radius: 9999px;\n  margin-bottom: 0.5rem;\n  letter-spacing: 0.03em;\n  box-shadow: 0 2px 8px rgba(1,151,141,0.08);\n}\n.modern-news-title {\n  font-size: 1.08rem;\n  font-weight: 700;\n  line-height: 1.35;\n  margin: 0;\n  text-shadow: 0 2px 8px rgba(0,0,0,0.10);\n}\n/* Modern app card styles */\n.modern-app-card {\n  border-radius: 20px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.10);\n  padding: 1.5rem 1rem;\n  transition: transform 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n.modern-app-card:hover {\n  transform: translateY(-6px) scale(1.04);\n  box-shadow: 0 12px 32px rgba(0,0,0,0.16);\n}\n.dashboard-app-icon-wrapper {\n  border-radius: 16px !important;\n  width: 64px !important;\n  height: 64px !important;\n  margin-bottom: 16px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.07) !important;\n  background: rgba(255,255,255,0.85) !important;\n}\n.dashboard-app-title {\n  font-weight: 700;\n  font-size: 1.15rem;\n  color: #222;\n  margin-bottom: 4px;\n}\n.dashboard-app-subtitle {\n  font-size: 0.95rem;\n  color: #555;\n  font-weight: 500;\n}\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n:root {\n  --awlone-brand-color: #01978d;\n  --text-dark: #1f2937;\n  --text-medium: #6b7280;\n  --card-border: #e5e7eb;\n  --card-bg: #ffffff;\n  --shadow-light: rgba(4, 29, 56, 0.05);\n  --shadow-hover: rgba(4, 29, 56, 0.12);\n  --primary-font: 'Inter', sans-serif;\n}\n\n.home-dashboard-bg {\n  font-family: var(--primary-font);\n  background-color: #f9fafb;\n}\n\n.sticky-top-header {\n  position: sticky;\n  top: 0;\n  background-color: var(--card-bg);\n  box-shadow: 0 4px 12px var(--shadow-light);\n  z-index: 1000;\n  padding: 0.8rem 1.5rem;\n  display: flex;\n  justify-content: center;\n}\n.portal-branding { display: flex; align-items: center; justify-content: space-between; width: 100%; max-width: 800px; }\n.portal-title { font-size: 1.8rem; font-weight: 800; color: var(--awlone-brand-color); }\n.profile-icon-container { color: var(--text-medium); cursor: pointer; transition: color 0.2s; }\n.profile-icon-container:hover { color: var(--awlone-brand-color); }\n\n.main-content-area {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 1.5rem;\n  box-sizing: border-box;\n}\n\n.section-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-dark);\n  margin-bottom: 1rem;\n}\n\n.news-section {\n  margin-bottom: 2.5rem;\n}\n\n.news-carousel-container {\n  display: flex;\n  gap: 1rem;\n  overflow-x: auto; \n  padding-bottom: 1rem; \n  -ms-overflow-style: none;  \n  scrollbar-width: none; \n}\n  .marquee-wrapper {\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n  }\n  .marquee-inner {\n    display: flex;\n    animation: marquee-scroll 16s linear infinite;\n  }\n  @keyframes marquee-scroll {\n    0% { transform: translateX(0); }\n    100% { transform: translateX(-60%); }\n  }\n.news-carousel-container::-webkit-scrollbar {\n  display: none; \n}\n\n.news-card {\n  flex: 0 0 280px; \n  height: 180px;\n  position: relative;\n  border-radius: 1rem;\n  overflow: hidden;\n  box-shadow: 0 4px 12px var(--shadow-light);\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.news-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px var(--shadow-hover);\n}\n\n.news-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.news-card-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 60%);\n}\n\n.news-card-content {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 1rem;\n  color: white;\n}\n.news-category {\n  font-size: 0.75rem;\n  font-weight: 600;\n  background-color: var(--awlone-brand-color);\n  padding: 0.25rem 0.6rem;\n  border-radius: 9999px;\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n.news-title {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n/* Two-column grid for apps, always mobile-friendly */\n.dashboard-apps-container.two-column {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.25rem;\n}\n\n@media (max-width: 700px) {\n  .dashboard-apps-container.two-column {\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    padding: 0 0.5rem;\n  }\n}\n\n.dashboard-app-module {\n  text-align: center;\n  cursor: pointer;\n}\n.dashboard-app-icon-wrapper {\n  width: 80px; \n  height: 80px; \n  border-radius: 1.25rem;\n  background-color: var(--card-bg);\n  box-shadow: 0 4px 12px var(--shadow-light);\n  border: 1px solid var(--card-border);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 0.75rem;\n  padding: 0.75rem;\n  box-sizing: border-box;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.dashboard-app-module:hover .dashboard-app-icon-wrapper {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px var(--shadow-hover);\n}\n\n.app-logo-img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.dashboard-app-title {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-dark);\n}\n\n\n@media (max-width: 600px) {\n  .dashboard-apps-container {\n    grid-template-columns: repeat(3, 1fr); \n    gap: 1rem;\n  }\n  .dashboard-app-icon-wrapper {\n      width: 70px;\n      height: 70px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
